import { LanguageStateModel } from './language.types';

export const defaultState: LanguageStateModel = {
  currentLang: null,
  defaultLang: null,
  languages: [],
};
